import {trackPromotionInteraction} from '@aboutyou/legacy-tracking-sdk';
import {
  Promotion,
  RecoListTrackingData,
} from '../trackerComponents/TrackPromotions';
import {getPromotionData} from '../utils/promotionDataGetter';
import {useTracking} from '../utils/utils';

interface TrackPromotionInterface {
  promotion: Promotion;
  recoList?: RecoListTrackingData;
  streamPosition: number;
  actionType: 'click' | 'impression';
}

export const useTrackPromotion = () => {
  const {pageContextCallback, TrackingClient} = useTracking();

  return ({
    promotion,
    recoList,
    streamPosition,
    actionType,
  }: TrackPromotionInterface) => {
    const promotionData = getPromotionData({
      promotion,
      streamPosition,
      recoList,
      pageType: pageContextCallback().type,
    });

    const promotionInteractionData = trackPromotionInteraction({
      ...promotionData,
      type: actionType,
    });

    TrackingClient.track(promotionInteractionData);
  };
};
